import React from "react";
import { Link } from "react-router-dom";
import newLogo from "../../assets/global/navbar/vision-security-logo.webp";
import "./Logo.css";

const Logo = () => {
  return (
    <div className="flex__center logo__container">
      <Link to="/" className="logo__link" aria-label="Go to homepage">
        <img src={newLogo} alt="Vision Security" width={180} height={48} decoding="async" />
      </Link>
    </div>
  );
};

export default Logo;
